var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolCollectionReminders01 = function SvgSolCollectionReminders01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_collection_reminders-01_svg2__a",
    x1: 46.65,
    x2: 194.04,
    y1: 181.4,
    y2: 15.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__b",
    x1: 37.06,
    x2: 184.45,
    y1: 172.87,
    y2: 7.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__c",
    x1: 10.41,
    x2: 157.8,
    y1: 149.12,
    y2: -16.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__d",
    x1: 35.48,
    x2: 182.87,
    y1: 171.45,
    y2: 5.99
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__e",
    x1: -5.5,
    x2: 141.89,
    y1: 134.95,
    y2: -30.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__f",
    x1: 8.83,
    x2: 156.22,
    y1: 147.72,
    y2: -17.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__g",
    x1: 23.17,
    x2: 170.56,
    y1: 160.49,
    y2: -4.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__h",
    x1: 37.5,
    x2: 184.89,
    y1: 173.25,
    y2: 7.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__i",
    x1: 51.67,
    x2: 199.05,
    y1: 185.87,
    y2: 20.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__j",
    x1: 5.93,
    x2: 153.32,
    y1: 145.13,
    y2: -20.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__k",
    x1: 20.27,
    x2: 167.65,
    y1: 157.9,
    y2: -7.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__l",
    x1: 34.6,
    x2: 181.99,
    y1: 170.67,
    y2: 5.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__m",
    x1: 48.93,
    x2: 196.32,
    y1: 183.44,
    y2: 17.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__n",
    x1: 63.1,
    x2: 210.48,
    y1: 196.05,
    y2: 30.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__o",
    x1: 46.18,
    x2: 193.57,
    y1: 180.98,
    y2: 15.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__p",
    x1: 60.51,
    x2: 207.9,
    y1: 193.75,
    y2: 28.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__q",
    x1: 74.68,
    x2: 222.06,
    y1: 206.37,
    y2: 40.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__r",
    x1: 57.76,
    x2: 205.15,
    y1: 191.3,
    y2: 25.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__s",
    x1: 72.09,
    x2: 219.48,
    y1: 204.07,
    y2: 38.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_collection_reminders-01_svg2__a",
    id: "sol_collection_reminders-01_svg2__t",
    x1: 86.26,
    x2: 233.64,
    y1: 216.68,
    y2: 51.23
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.09 155.64c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91h-13.8c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.87 163.48v-48.04c0-6.13-4.99-11.12-11.12-11.12H30.59c-6.13 0-11.12 4.99-11.12 11.12v11.01c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-11.01c0-2.92 2.37-5.29 5.29-5.29H44.9v16.3c0 1.09.61 2.09 1.58 2.59s2.14.41 3.03-.22l8.15-5.84 8.15 5.84c.5.36 1.1.55 1.7.55.46 0 .91-.11 1.33-.32.97-.5 1.58-1.5 1.58-2.59v-16.3h14.32c2.92 0 5.29 2.38 5.29 5.29v50.33l-12.71 5.37c0-.08.02-.16.02-.24 0-4.91-4-8.9-8.9-8.9H56.8l-6.59-2.92c-6.58-2.91-14.3-2.71-20.82.22v-1.4c0-1.61-1.3-2.91-2.91-2.91h-1.19v-10.08c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91V155H3.1c-1.61 0-2.91 1.3-2.91 2.91v39.18c0 1.61 1.3 2.91 2.91 2.91h23.38c1.61 0 2.91-1.3 2.91-2.91v-1.19h25.04c10.81 0 21.64-2.55 31.31-7.36l16.14-8.03a9.12 9.12 0 0 0 4.76-5.86c.66-2.55.19-5.26-1.3-7.43-2.12-3.1-5.92-4.52-9.49-3.74Zm-31.27-42.7-5.24-3.75c-.51-.36-1.1-.55-1.7-.55s-1.19.18-1.7.55l-5.24 3.75v-10.63h13.87v10.63ZM6.01 194.17v-33.36h17.56v31.52c-.05.21-.08.42-.08.65s.03.44.08.65v.54zm95-20.99c-.24.93-.85 1.68-1.71 2.11l-16.14 8.03c-8.87 4.42-18.81 6.75-28.72 6.75H29.4v-24.14c5.45-3.46 12.55-4.15 18.46-1.53l7.16 3.17c.37.16.77.25 1.18.25h12.26c1.7 0 3.08 1.38 3.08 3.08s-1.38 3.08-3.08 3.08H50.99c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h17.98c1.88 0 3.71-.37 5.44-1.1l22.17-9.37a3.3 3.3 0 0 1 3.98 1.17c.54.79.71 1.74.47 2.67Z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.69 136.79c.08.17.17.35.27.5.1.16.23.31.37.45.54.54 1.28.85 2.06.85a2.635 2.635 0 0 0 1.1-.24c.17-.06.35-.15.5-.25.16-.12.31-.23.45-.37s.25-.29.35-.45c.12-.16.2-.33.27-.5.08-.18.13-.35.17-.54.04-.17.06-.37.06-.56 0-.78-.31-1.51-.85-2.06-.14-.14-.29-.25-.45-.37-.16-.1-.33-.19-.5-.27-.17-.06-.37-.12-.54-.15-.95-.19-1.94.12-2.62.8-.54.54-.87 1.28-.87 2.06 0 .19.04.39.08.56.02.19.08.37.16.54Z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25 14.36h-7.47V8.01c0-4.33-3.66-7.99-7.99-7.99h-4.78c-4.33 0-7.99 3.66-7.99 7.99v6.35h-18.69V8.01c0-4.33-3.66-7.99-7.99-7.99h-4.78c-4.33 0-7.99 3.66-7.99 7.99v6.35h-18.69V8.01c0-4.33-3.66-7.99-7.99-7.99h-4.78c-4.33 0-7.99 3.66-7.99 7.99v6.35H64.43V8.01c0-4.33-3.66-7.99-7.99-7.99h-4.78c-4.33 0-7.99 3.66-7.99 7.99v6.35h-7.25c-5.4 0-9.79 4.52-9.79 10.09v71.44c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V41.41h161.56v103.5c0 1.08-.79 1.87-1.87 1.87h-86.38c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h86.38c4.32 0 7.69-3.38 7.69-7.69V24.43c0-5.33-4.11-9.66-9.56-10.08Zm-22.42-6.37c0-1.07 1.09-2.17 2.17-2.17h4.78c1.08 0 2.17 1.09 2.17 2.17v11.66c0 1.05-.76 2.17-2.17 2.17H170c-1.07 0-2.17-1.1-2.17-2.17zm-39.45 0c0-1.07 1.09-2.17 2.17-2.17h4.78c1.08 0 2.17 1.09 2.17 2.17v11.66c0 1.07-1.09 2.17-2.17 2.17h-4.78c-1.07 0-2.17-1.1-2.17-2.17zm-39.46 0c0-1.07 1.09-2.17 2.17-2.17h4.78c1.08 0 2.17 1.09 2.17 2.17v11.66c0 1.07-1.09 2.17-2.17 2.17h-4.78c-1.07 0-2.17-1.1-2.17-2.17zm-39.45 0c0-1.07 1.09-2.17 2.17-2.17h4.78c1.07 0 2.17 1.09 2.17 2.17v11.66c0 1.07-1.09 2.17-2.17 2.17h-4.78c-1.07 0-2.17-1.1-2.17-2.17zM32.43 24.43c0-2.35 1.78-4.26 3.96-4.26h6.95v.38c0 3.98 3.12 7.1 7.1 7.1h7.17c3.85 0 7.1-3.25 7.1-7.1v-.38H83.1v.38c0 3.85 3.25 7.1 7.1 7.1h6.87c3.98 0 7.1-3.12 7.1-7.1v-.38h18.39v.38c0 3.85 3.25 7.1 7.1 7.1h6.88c3.98 0 7.1-3.12 7.1-7.1v-.38h18.39v.38c0 3.98 3.12 7.1 7.1 7.1h6.88c3.85 0 7.1-3.25 7.1-7.1v-.38h6.83c2.37.23 4.09 2 4.09 4.26v11.14H32.43z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32 69.79h14.95c1.61 0 2.91-1.3 2.91-2.91V51.93c0-1.61-1.3-2.91-2.91-2.91H54.32c-1.61 0-2.91 1.3-2.91 2.91v14.95c0 1.61 1.3 2.91 2.91 2.91m2.92-14.95h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.03 69.79h14.95c1.61 0 2.91-1.3 2.91-2.91V51.93c0-1.61-1.3-2.91-2.91-2.91H80.03c-1.61 0-2.91 1.3-2.91 2.91v14.95c0 1.61 1.3 2.91 2.91 2.91m2.91-14.95h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 69.79h14.95c1.61 0 2.91-1.3 2.91-2.91V51.93c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91v14.95c0 1.61 1.3 2.91 2.91 2.91m2.91-14.95h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.44 69.79h14.95c1.61 0 2.91-1.3 2.91-2.91V51.93c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91v14.95c0 1.61 1.3 2.91 2.91 2.91m2.91-14.95h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85 69.79h14.94c1.61 0 2.91-1.3 2.91-2.91V51.93c0-1.61-1.3-2.91-2.91-2.91h-14.94c-1.61 0-2.91 1.3-2.91 2.91v14.95c0 1.61 1.3 2.91 2.91 2.91m2.91-14.95h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.41 89.89c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91V74.95c0-1.61-1.3-2.91-2.91-2.91H54.32c-1.61 0-2.91 1.3-2.91 2.91zm5.83-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12 89.89c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91V74.95c0-1.61-1.3-2.91-2.91-2.91H80.03c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82 89.89c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91V74.95c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91zm5.83-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53 89.89c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91V74.95c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94 89.89c0 1.61 1.3 2.91 2.91 2.91h14.94c1.61 0 2.91-1.3 2.91-2.91V74.95c0-1.61-1.3-2.91-2.91-2.91h-14.94c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82 113.21c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91V98.26c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91zm5.83-12.04h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53 113.21c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91V98.26c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.04h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94 113.21c0 1.61 1.3 2.91 2.91 2.91h14.94c1.61 0 2.91-1.3 2.91-2.91V98.26c0-1.61-1.3-2.91-2.91-2.91h-14.94c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.04h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82 136.52c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91v-14.95c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91zm5.83-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53 136.52c0 1.61 1.3 2.91 2.91 2.91h14.95c1.61 0 2.91-1.3 2.91-2.91v-14.95c0-1.61-1.3-2.91-2.91-2.91h-14.95c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94 136.52c0 1.61 1.3 2.91 2.91 2.91h14.94c1.61 0 2.91-1.3 2.91-2.91v-14.95c0-1.61-1.3-2.91-2.91-2.91h-14.94c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.03h9.12v9.12h-9.12z",
    style: {
      fill: "url(#sol_collection_reminders-01_svg2__t)"
    }
  }));
};
export default SvgSolCollectionReminders01;